import { render, staticRenderFns } from "./ListagemAvisoPrevio.vue?vue&type=template&id=bb8cd98c"
import script from "./ListagemAvisoPrevio.vue?vue&type=script&lang=js"
export * from "./ListagemAvisoPrevio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports